import { call, put, all, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_EMPLOYEE_RECORD_VALUE,
  SG_GET_EMPLOYEE_RECORD_VALUE,
  ADD_EMPLOYEE_RECORD_VALUE,
  SG_ADD_EMPLOYEE_RECORD_VALUE,
  DELETE_EMPLOYEE_RECORD_VALUE,
  SG_DELETE_EMPLOYEE_RECORD_VALUE,
  UPDATE_EMPLOYEE_RECORD_VALUE,
  SG_UPDATE_EMPLOYEE_RECORD_VALUE,
  FETCH_EMPLOYEE_RECORD_VALUE,
  SG_FETCH_EMPLOYEE_RECORD_VALUE,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";


function* loadmethods(action) {
  //   yield put({ type: GET_methodS_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_EMPLOYEE_RECORD_VALUE, action.payload);
    yield put({ type: GET_EMPLOYEE_RECORD_VALUE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_EMPLOYEE_RECORD_VALUE, loadmethods);
}

function* fetchmethods(action) {
  try {
    const json = yield call(api.FETCH_EMPLOYEE_RECORD_VALUE, action.payload);
    yield put({ type: FETCH_EMPLOYEE_RECORD_VALUE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_EMPLOYEE_RECORD_VALUE, fetchmethods);
}

function* updatemethods(action) {
  try {
    const json = yield call(api.UPDATE_EMPLOYEE_RECORD_VALUE, action.payload);
    yield put({ type: UPDATE_EMPLOYEE_RECORD_VALUE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeEvery(SG_UPDATE_EMPLOYEE_RECORD_VALUE, updatemethods);
}

function* addmethods(action) {
  try {
    const json = yield call(api.ADD_EMPLOYEE_RECORD_VALUE, action.payload);       
    yield put({ type: ADD_EMPLOYEE_RECORD_VALUE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_EMPLOYEE_RECORD_VALUE, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_EMPLOYEE_RECORD_VALUE, action.payload);
    yield put({ type: DELETE_EMPLOYEE_RECORD_VALUE, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_EMPLOYEE_RECORD_VALUE, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
